import { createCrud } from '../../CRUD';
import { TMessageTemplatePartial } from './types';

export const messageTemplatePartialBaseModel =
  createCrud<TMessageTemplatePartial>(
    'messageTemplatePartials',
    'MessageTemplatePartials',
  );
